/**
 * API Configuration – TMS Admin
 * URL unique : https://tms.ideumagency.com/backend_laravel/public/api
 */

const API_BASE_URL = process.env.NODE_ENV === 'production'
  ? 'https://tms.ideumagency.com/backend_laravel/public/api'
  : 'https://tms.ideumagency.com/backend_laravel/public/api';


/* const API_BASE_URL = 'https://tms.ideumagency.com/backend_laravel/public/api'; */

const getApiUrl = () => {
  return process.env.REACT_APP_API_URL || API_BASE_URL;
};

export const API = getApiUrl();

// Export for backwards compatibility
export default API;
